import {BENEFITS_BRANDS} from 'constants/uhc';
import {getCurrentUhcCookie} from 'libs/getCurrentUhcCookie/getCurrentUhcCookie';
import {isUhcEnabled} from 'libs/rollout';

/**
 * Return UHC brand
 * @returns {object} UNC brand info
 */
export const getCurrentBenefitsBrand = () => {
    if (!isUhcEnabled()) {
        throw new Error(
            `Only for UHC functional, cookie "in_network" should be required, and shall contain: ${Object.keys(
                BENEFITS_BRANDS,
            )} one of the values`,
        );
    }
    return BENEFITS_BRANDS[getCurrentUhcCookie()];
};
